// extracted by mini-css-extract-plugin
module.exports = {"InsuranceCont":"insurance_InsuranceCont__7QIWP","LogoCont":"insurance_LogoCont__1rci0"};